<template>
	<div class="language-main" :class="!isPc?'language-main-mobile' :''" v-show="isLanguage" @click.stop="closeModal()">
		<div class="content" @click.stop="">
			<div class="title">{{ $t('account.changeLanguage') }}</div>
			<div class="content-box">
				<div class="box " :class="{ 'box-active': langIndex == index }" @click="langChange(index)"
					v-for="(item, index) in langList" :key="index">{{ item.name }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from "vuex";
	export default {
		name: 'Languages',
		data() {
		  return {
			
		  }
		},
		props:{
			isPc:{
				type:Boolean,
				default:false
			},
			isLanguage:{
				type:Boolean,
				default:false
			}
		},
		computed: {
		  ...mapGetters(["langList", "langIndex"]),
		},
		methods: {
			langChange(index) {
				// this.langIndex=index;
				// this.$store.commit('SET_LANG', this.langList[index].value);
			
				let lang = this.langList[index].value;
				this.closeModal();
				this.$store.commit('SET_LANG', lang);
				this.$store.dispatch('listContents', lang == 'zh' ? 1 : 2);
			},
			closeModal() {
				this.$emit('close');
			},
		},
	}
</script>

<style>
	/* BORYX_LANGUAGE_V1_3_4_MOBILE_THEME */
	.language-main {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .72);
		backdrop-filter: blur(5px);
		-webkit-backdrop-filter: blur(5px);
		display: flex;
		justify-items: center;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: .2rem;
	}
	
	.language-main .content {
		width: 4.32rem;
		max-width: 100%;
		box-sizing: border-box;
		background:
			radial-gradient(circle at 82% 8%, rgba(201, 154, 77, .16), transparent 32%),
			linear-gradient(155deg, #111721 0%, #070a0f 72%, #030507 100%);
		border: 1px solid rgba(232, 201, 138, .48);
		border-radius: .16rem;
		padding: .24rem .32rem;
		color: #f5f6f8 !important;
		text-align: center;
		box-shadow:
			0 .24rem .64rem rgba(0, 0, 0, .48),
			0 0 .24rem rgba(201, 154, 77, .12),
			inset 0 1px rgba(255, 255, 255, .05);
	}
	
	.language-main .content .title {
		font-weight: 500;
		font-size: .2rem;
		line-height: 1.4;
		margin-bottom: .2rem;
		color: #f0d59d !important;
		text-shadow: 0 0 .12rem rgba(232, 201, 138, .18);
	}
	
	.language-main .content .content-box {
		cursor: pointer;
		width: 3.16rem;
		max-width: 100%;
		margin: auto;
	}
	
	.language-main .content .content-box .box {
		width: 3.16rem;
		max-width: 100%;
		height: .46rem;
		box-sizing: border-box;
		border: 1px solid rgba(232, 201, 138, .42);
		border-radius: .24rem;
		line-height: .46rem;
		margin-bottom: .16rem;
		color: #d9dde3 !important;
		background: linear-gradient(135deg, rgba(232, 201, 138, .1), rgba(201, 154, 77, .035));
		box-shadow: inset 0 1px rgba(255, 255, 255, .035);
		transition: color .2s ease, border-color .2s ease, background .2s ease, box-shadow .2s ease, transform .2s ease;
	}

	.language-main .content .content-box .box:hover {
		transform: translateY(-1px);
		border-color: rgba(240, 213, 157, .82);
		color: #f0d59d !important;
		background: rgba(201, 154, 77, .18);
		box-shadow: 0 0 .18rem rgba(232, 201, 138, .14);
	}
	
	.language-main .content .content-box .box-active {
		border-color: #f2d79a !important;
		background: linear-gradient(135deg, #f0d59d 0%, #c89542 58%, #f1cb82 100%) !important;
		color: #090b0e !important;
		font-weight: 600;
		box-shadow: 0 .08rem .22rem rgba(201, 154, 77, .28), 0 0 .18rem rgba(242, 184, 91, .18) !important;
	}
	
	.language-main-mobile {
		z-index: 81;
	}
	
	.language-main-mobile .content {
		max-height: 80%;
		overflow: auto;
	}

	@media (max-width: 1000px) {
		.language-main-mobile {
			padding: .16rem;
		}

		.language-main-mobile .content {
			width: calc(100vw - .32rem);
			padding: .24rem .28rem .18rem;
		}

		.language-main-mobile .content .content-box {
			width: 100%;
		}

		.language-main-mobile .content .content-box .box {
			width: 100%;
		}
	}
</style>
